import {TSBeitragType} from './enums/TSBeitragType';
import TSBeitrag from './TSBeitrag';

export default class TSBeitragDTO {
    private _schadenfallId: string;
    private _fallNummer: string;
    private _ereignis: string;
    private _amtsstelleName: string;
    private _ort: string;
    private _ermittelterSchaden: number;
    private _beitragType: TSBeitragType;

    private _beitraege: Array<TSBeitrag>;

    public get fallNummer(): string {
        return this._fallNummer;
    }

    public set fallNummer(value: string) {
        this._fallNummer = value;
    }

    public get ereignis(): string {
        return this._ereignis;
    }

    public set ereignis(value: string) {
        this._ereignis = value;
    }

    public get amtsstelleName(): string {
        return this._amtsstelleName;
    }

    public set amtsstelleName(value: string) {
        this._amtsstelleName = value;
    }

    public get ort(): string {
        return this._ort;
    }

    public set ort(value: string) {
        this._ort = value;
    }

    public get schadenfallId(): string {
        return this._schadenfallId;
    }

    public set schadenfallId(value: string) {
        this._schadenfallId = value;
    }

    public get beitraege(): Array<TSBeitrag> {
        return this._beitraege;
    }

    public set beitraege(value: Array<TSBeitrag>) {
        this._beitraege = value;
    }

    public get ermittelterSchaden(): number {
        return this._ermittelterSchaden;
    }

    public set ermittelterSchaden(value: number) {
        this._ermittelterSchaden = value;
    }

    public get beitragType(): TSBeitragType {
        return this._beitragType;
    }

    public set beitragType(value: TSBeitragType) {
        this._beitragType = value;
    }

    public extractGroupLabel(): string {
        let label = this.ort + '_' + this.fallNummer;
        if (this.ereignis !== undefined && this.ereignis !== null) {
            label += ' (' + this.ereignis + ')';
        }
        return label;

    }

    deserialize(restObject: any): TSBeitragDTO {
        this.schadenfallId = restObject.schadenfallId;
        this.fallNummer = restObject.fallNummer;
        this.ereignis = restObject.ereignis;
        this.amtsstelleName = restObject.amtsstelleName;
        this.ermittelterSchaden = restObject.ermittelterSchaden;
        this.ort = restObject.ort;
        this.beitragType = restObject.beitragType;
        if (restObject.beitraege) {
            this.beitraege = restObject.beitraege.map(TSBeitrag.getDeserializer);
        }
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSBeitragDTO.ts